import { transparentTag as css } from '@tencent/exeditor3-core';
const picturePluginStyles = css `
  .exeditor-picture {
    display: block;
    position: relative;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .exeditor-picture > :first-child {
    display: block;
    margin: 0 auto;
  }
  .exeditor-picture > :first-child:not(img) {
    width: fit-content;
    height: auto;
  }
  .exeditor-picture > .title {
    box-sizing: border-box;
    display: block;
    height: auto;
    max-width: 100%;
    margin-top: 0.5em;
    border: 0 none;
    outline: none;
    background-color: transparent;
    color: #666;
    font-size: 12px;
    text-align: center;
    word-break: break-all;
    resize: none;
  }
  .exeditor-picture > textarea.title {
    padding: 0;
    width: 100%;
    overflow: hidden;
  }
  .exeditor-picture > img {
    display: block;
    max-width: 100%;
    height: auto;
  }
  exeditor-picture-block-container[active]:not([editable]) {
    outline: var(--exeditor-selected-outline);
  }

  /* inline */
  span.exeditor-picture {
    display: inline-block;
    margin: 0 2px;
  }
  span.exeditor-picture > img {
    max-width: unset;
  }
`;
export default picturePluginStyles;
//# sourceMappingURL=styles.js.map